import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { BaseNewsletter } from '@/components/blogHome/BaseNewsletter';

/**
 * Props for `NewsLetter`.
 */
export type NewsLetterProps = SliceComponentProps<
  Content.NewsLetterSlice,
  Record<string, string>
>;

/**
 * Component for "NewsLetter" Slices.
 */
const NewsLetter = ({ slice, context }: NewsLetterProps): JSX.Element => {
  return (
    <BaseNewsletter
      slice_type={slice.slice_type}
      button_label={slice.primary.button_label}
      disclaimer={slice.primary.disclaimer}
      email_placeholder={slice.primary.email_placeholder}
      formId={slice.primary.formId}
      hubspotPortalIdForm={context.hubspotPortalIdForm}
      invite_text={slice.primary.invite_text}
      title={'title' in slice.primary ? slice.primary.title : 'Subscribe'}
      variation={slice.variation}
    />
  );
};

export default NewsLetter;
